import { combineReducers } from "@reduxjs/toolkit";
import authentication from "./authentication";
import createProfile from "./createProfile";
import loader from "./loader";
import payments from "./payments";
import invoices from "./invoices";

const rootReducer = combineReducers({
  loader,
  authentication,
  createProfile,
  payments,
  invoices
});

export default rootReducer;
